export default __webpack_public_path__ + "static/media/logo.8e3ce183.svg";